import { callRpc } from "./client";

export interface ResumoMinhaConta {
  sucesso: boolean;
  saldo: number;
  erro?: string;
}

/** Consulta somente dados da organização atual e nunca expõe a chave da IA. */
export async function obterResumoMinhaConta(): Promise<ResumoMinhaConta> {
  const resposta = await callRpc<ResumoMinhaConta>("obterMinhaContaCreditos");
  if (!resposta?.sucesso) throw new Error(resposta?.erro || "Não foi possível carregar os créditos de IA.");
  return resposta;
}
